const YES_VALUES = new Set(['yes', 'y', 'true']);
const NO_VALUES = new Set(['no', 'n', 'false', 'n/a']);

/**
 * Interprets marital-status and yes/no answers from forms, Kentico choice
 * values, and choice codenames (`yes___are_you_married`).
 * Returns null when the value is missing or unrecognized.
 */
export function parseYesNoValue(value: unknown): boolean | null {
  if (value === true || value === false) {
    return value;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  if (YES_VALUES.has(normalized)) {
    return true;
  }
  if (NO_VALUES.has(normalized)) {
    return false;
  }

  // Kentico input-choice codenames: yes___slug, no___slug, slug___yes
  if (
    normalized.startsWith('yes_') ||
    normalized.endsWith('_yes') ||
    normalized.includes('___yes___')
  ) {
    return true;
  }
  if (
    normalized.startsWith('no_') ||
    normalized.endsWith('_no') ||
    normalized.includes('___no___')
  ) {
    return false;
  }

  return null;
}
